require('babel-polyfill');
const $ = require('jquery');
// shimované pluginy většinou nemají export, většinou extendují jQuery object
require('fg-frontend/third/jquery.cookie');
require('./web/highslide-settings');
require('fg-frontend/plugins/jquery.universal-pagination.js');
require('./web/jquery.simple-scroll-to');
require('./web/jquery.awards');
require('./web/jquery.simple-collapse');
require('./web/jquery.radioselect-iterate-check');
require('./web/jquery.gallery-support');
require('./web/jquery.social-share');
require('./web/jquery.ingredients');
require('./web/jquery.accordeon');
require('./web/jquery.tags-autocomplete');
require('./web/jquery.fg-autocomplete');
require('./web/jquery.feed-agetags-select');
require('./third/plUpload/fg.upload');
require('./web/jquery.pickmeup');
require('./web/jquery.protected-content');
require('./web/jquery.activate-video-player');
require('./web/jquery.simple-toggle');
require('./web/jquery.curtain-webslider');
require('./web/jquery.profile-dialog-form');
require('./web/jquery.faq');
require('./web/jquery.sticky-kit');
require('select2');
const Curtain = require('./web/Curtain');
const CurtainScrollHandler = require('./web/CurtainScrollHandler');
const Utils = require('./web/utils');
const autosize = require('autosize');
const BrandDisclaimer = require('./web/BrandDisclaimer');
const LocalStorageSupport = require('./web/LocalStorageSupport');
require('./ramjet/MultipleWidgetContainer');
const moment = require('moment');

// gtm events binding
// require('./gtm-event/article-editor-send-for-approval');
require('./gtm-event/video-events');

import gaDimensionUser from './gtm-event/dimension-user';
import gaDimensionChildAge from './gtm-event/dimension-child-age';
import gaSeachForm from './gtm-event/search-events';
import gaCtaBannerEvents from './gtm-event/cta-events';

const LastVisitedUrlEnhanced = require('./web/LastVisitedUrlEnhanced');

import GravCalc from './apps/GravCalc';
import ArticlesDottedBorder from './web/ArticlesDottedBorder';

ArticlesDottedBorder();

// user support
window.user = window.user || {};

// export to window
window.$ = $;
window.jQuery = $;
window.lss = new LocalStorageSupport();
window.GravCalc = GravCalc;

// tags support
window.feedTags = [];
window.feedTagsMetadata = {};
window.initialTags = [];
window.ageTags = [];
window.feedActualUrl = '';
window.frontendAuthorTagUsed = false;

// product autocomplete
window.initProducts = {};

// global function
window._isTouchDevice = function () { try { document.createEvent('TouchEvent'); return true; } catch (e) { return false; } };

// promenne pro dalsi pouziti
const $b = $('body');

/**
 *
 */
window.Curtain = Curtain;
const $curtain = $('#curtain-container');
if ($curtain.size() > 0 && $curtain.data('curtainInstance')) {
} else {
  window.curtainInstance = new Curtain('#curtain-container', {
    lang: window.projectConfig.lang
  });
}
$(() => {
  $curtain.on('CURTAIN_CURTAIN_CHANGED', (e, slide) => {
    if (slide instanceof $ && $('.author-motive', slide).size() == 0) {
      if ($('.tags-list', slide).data('plugin_curtainSlider')) {
        $('.tags-list', slide).curtainSlider('reinitSlider');
      } else {
        $('.tags-list', slide).curtainSlider({
          itemSelector: '> li'
        });
      }
    }
  });

  // curtain
  $('.js_hide-on-scroll').each(() => {
    $('html, body').animate({ scrollTop: 1 }, 0, () => {
      window.setTimeout(() => {
        const curtainScrollHandler = new CurtainScrollHandler('.js_hide-on-scroll', {});
      }, 500);
    });
    $('.js_hide-on-scroll, .curtain-placeholder').hide();
    $('#curtain-container').data('doNotInitiallyShow', '1');
  });

  $('.js_manual-curtain-slider').curtainSlider({
    itemSelector: '> li'
  });
});

$(() => {
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const documentHeight = Math.max(document.documentElement.clientHeight, document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight);

  if (documentHeight - windowHeight > 300) {
    $('.js_make-curtain-hidable').each(() => {
      const curtainScrollHandler = new CurtainScrollHandler('.js_make-curtain-hidable', {});
    });
  }
});

$(() => {
  let logoTimeout = null;
  $(window).off('scroll.logoMobile').on('scroll.logoMobile', (event) => {
    const scrollTop = (window.pageYOffset || document.documentElement.scrollTop);
    clearTimeout(logoTimeout);
    logoTimeout = window.setTimeout(() => {
      if (scrollTop >= 1) {
        // hide logo
        if ($(window).width() < 768) {
          $('body').addClass('hide-mobile-logo');
        }

        // force hide curtain if has fixed position and no static content
        const $curtain = $('#curtain-container');
        const curtainInstance = $curtain.data('curtainInstance');

        if ($curtain.data('curtainScrollHandlerApplied') != '1' && !$curtain.hasClass('js_hide-on-scroll')) {
          curtainInstance.forceCloseCurtain();
        }
      } else if ($(window).width() < 768) {
        $('body').removeClass('hide-mobile-logo');
      }
    }, 100);
  });

  $(document).on('click', '#ramJetLayoutContext_loginPopup_lostPassword', function () {
	  const val = $('#ramJetLayoutContext_loginPopup_login').val();
	  if (val != '') {
	    let href = $(this).attr('href');
	    href = `${href}?frm.login=${val}`;
	    $(this).attr('href', href);
	  }
  });

  $(document).on('click', '#lostPassword', function () {
	  const val = $('#login').val();
	  if (val != '') {
	    let href = $(this).attr('href');
	    href = `${href}?frm.login=${val}`;
	    $(this).attr('href', href);
	  }
  });

  $('table.table').each(function () {
    $(this).wrap('<div class="table-responsive"></div>');
  });
});

/**
 * BrandDisclaimer
 */
const brandDisclaimerInstance = new BrandDisclaimer({
  url: '/cs/disclaimer.js',
  htmlClass: 'km-brand-disclaimer'
});
$b.on('KM_DISCLAIMER_NEEDED', () => {
  brandDisclaimerInstance.showDisclaimer();
});


const AP_brandDisclaimerInstance = new BrandDisclaimer({
  url: '/cs/disclaimer.js',
  htmlClass: 'km-brand-disclaimer',
  localStorageKey: 'KM_FLAG_PRODUCT_DISCLAIMER_AGREED_AP'
});
$b.on('KM_DISCLAIMER_NEEDED_AP', () => {
  AP_brandDisclaimerInstance.showDisclaimer();
});

/**
 * utils init
 */

const utils = new Utils();
window.utils = utils;

/**
 * autosize
 */
autosize(document.querySelectorAll('.js_autosize-textarea'));

/**
 * social share
 */
$('.share-links a[data-social-network]').socialShare();
$b.on('click', 'a[data-share]', (e) => {
  $(e.currentTarget).trigger('SOCIAL_SHARE_PERFORMED', [$(e.currentTarget)]);
});
$b.on('SOCIAL_SHARE_PERFORMED', (event, $link) => {
  const taskId = parseInt($link.data('taskId'));
  if ($.isNumeric(taskId)) {
    $.get(`/qf/cs/ramjet/approveSocialShareTask?taskId=${taskId}&eventName.approve:approve=`, () => {
      window.location.reload();
    });
  }
});


$b.simpleScrollTo({
  selector: '.js_scroll-to-element-by-href',
  offsetY: -105
});

$b.simpleCollapse({
  selector: '.js_simple-collapse-by-href'
});

$('.article-accordeon').accordeon({
  itemSelector: '.article-accordeon-item',
  closedItemClassName: 'closed',
  itemContentSelector: '.accordeon-item-content-container'
});

$('.product-awards').awards({
  itemSelector: '.item',
  controlButtonClassName: 'btn btn-default btn-sm',
  controlButtonWrapperClassName: 'ar'
});

$('.js_protected-part-target').each((index, item) => {
  const $t = $(item);
  let className = 'frontend-protected-part display-login-form';
  if (window.user && window.user.logged && !window.user.children) {
    className += ' display-children-warning';
  }
  if (window.user && !window.user.logged) {
    // $t.addClass(className);
  }
});

$('.display-login-form').protectedContent({
  buttonHtmlClass: 'btn btn-default btn-key js_last_visited_url_enhancement_launcher'
});

/**
 * aktivace videoJS playeru pro videa vložená v rámci TinyMCE editoru
 */
$('.js_transform-youtube-video').activateVideoPlayer();

/**
 * reset pagination when tags changed
 */
$b.on('AUTOCOMPLETE_TAGS_CHANGED AGE_TAG_CHANGED AUTOCOMPLETE_FULLTEXT_CHANGED', () => {
  if (window.history && window.history.state && window.history.state.universalPagination) {
    window.history.state.universalPagination = {};
  }
});

/**
 * rwd feed search
 */
if ($(window).width() < 480) {
  $('.feed-search-input input').attr('placeholder', 'Hledat');
}

/**
 * toggle form to request samples
 */
$('.js_allow-form').simpleToggle();

/**
 * datepicker on JS_PICKMEUP_DATEPICKER event
 */
$b.on('JS_PICKMEUP_DATEPICKER', (e) => {
  if (_isTouchDevice()) {
    $('input.js_dateinput').each((index, item) => {
      if ($(item).data('datePickerValueTransformed') != '1') {
        let val = $(item).val();
        if (val) {
          val = moment(val, 'DD. MM. YYYY');
        }
        // console.log(val, moment(val).format('YYYY-MM-DD'));
        $(item).val(moment(val).format('YYYY-MM-DD')).attr('type', 'date').removeAttr('readonly')
          .data('datePickerValueTransformed', '1');
      }
    });
  } else {
    $('input.js_dateinput').pickmeup({
      position: 'bottom',
      hide_on_select	: true,
      format  : 'd. m. Y',
      min: new Date(2010, 0, 1, 0, 0, 0, 0),
      // max: new Date(2020, 11, 31, 0, 0, 0, 0),
      locale			: {
        days		: ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota', 'Neděle'],
        daysShort	: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'],
        daysMin		: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'],
        months		: ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'],
        monthsShort	: ['Led', 'Ún', 'Bře', 'Dub', 'Kvě', 'Čen', 'Čec', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro']
      },
      view: 'days'
    });
  }
});

/**
 * universal pagination events
 */
$b.on('UP_BEFORE_CONTENT_RENDERED', (e, instance, pageNumber, paginationType) => {
  const $listing = $('.row.feed-listing');

  if (!$listing.data('defaultClass') || $listing.data('defaultClass') == '') {
    $listing.data('defaultClass', $listing.attr('class').replace('row feed-listing ', ''));
  }

  if (paginationType == 'numbers' && pageNumber > 1) {
    $listing.removeClass($listing.data('defaultClass'));
  }

  if (paginationType == 'numbers' && pageNumber == 1) {
    $listing.addClass($listing.data('defaultClass'));
  }
});

$b.on('UP_AFTER_PAGE_CHANGED', (e) => {
  $b.trigger('ARTICLE_LIST_RENDERED_OR_UPDATED');
});

/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
$.each(q, (index, f) => {
  $(f);
});

/**
 * plupload
 */
$(() => {
  $b.on('FGUploadComplete', '#motiveFile__container', (e, uploader, files) => {
    $('#motiveFile__container button').hide();
    $('.js_file-upload-display--motiveFile').hide();
  });

  $b.on('FGUploadComplete', '#videoFile__container', (e, uploader, files) => {
    $('#videoFile__container button').hide();
    $('.js_file-upload-display--videoFile').hide();
  });

  $b.on('FGUploadComplete', '#avatarFile__container', (e, uploader, files) => {
    utils.executePartialUpdate(uploader.settings.puUrl, 'puAvatar');
  });
});

// input type number
$('input[type=number]').on('keypress', (event) => {
  if ((event.which < 48 || event.which > 57) && event.which != 8 && event.which != 0 && event.which != 44 && event.which != 46) {
    event.preventDefault();
  }
});

/**
 * tinymce
 */

$b.on('REQUEST_TINYMCE_APPLY', (e, id) => {
  if (typeof tinymce == 'object') {
    tinymce.init({
      selector: id,
      statusbar: false,
      menubar: false,
      content_css: '/build/web-tinymce.css',
      language: 'cs_CZ',
      plugins: 'code, template, link',
      default_link_target: '_blank',
      toolbar1: 'formatselect | bold | bullist numlist blockquote | link unlink template | code',
      block_formats: 'Paragraph=p;Header 2=h2;Header 3=h3',
      templates: [
        { title: 'Blok se žárovkou (TIP)', description: 'Tento blok slouží ke zvýraznění zajímavé informace nebo tipu pro ostatní.', content: '<div class="tip"><p>Váš tip</p></div><p>Další text</p>' },
        { title: 'Nadpis H2 s nadtitulkem', description: '', content: '<h2><small>Nadtitulek</small> Nadpis H2</h2>' }
      ],
      setup(editor) {
        editor.on('change', () => {
          editor.save();
        });
      }
    });
  }
});

/**
 *
 */
$('select.js_select').select2({
  minimumResultsForSearch: Infinity
});

$(() => {
  $(document).bind('afterContentsReplaced', (e, settings) => {
    $('select.js_select').select2({
      minimumResultsForSearch: Infinity
    });
  });
});

/**
 * confirm before trash article
 *
 */

$('.js_confirm').on('click', (e) => {
  const confirmRequest = confirm('Opravdu si přejete příspěvek smazat?');
  if (confirmRequest) {
    return true;
  }
  e.preventDefault();
  return false;
});

/**
 * odscrollovani na rating v pripade ukolu, musi byt za $() inicializaci
 */
/*
$(() => {
  window.setTimeout(() => {
    const scrollToRating = window.location.href.indexOf('/cs/produkt') > -1 && window.location.href.indexOf('/hodnoceni') > -1;
    if (scrollToRating) {
      $('html, body').animate({ scrollTop: $('#scrollToRatingTarget').offset().top - 15 }, 200, () => {
        $('#rating-form').slideDown();
      });
    }
  }, 1000);
});
*/


/* landing page */
$(() => {
  $(document).on('click', '.lpFoodFloatingMenu ul li a, .viaggioListYellowSection ul li .viaggioBtn, .viaggioScrollLink', function (e) {
    e.preventDefault();
    const href = $(this).attr('href');
    const hrefOffset = $(href).offset().top - $('.p-header').outerHeight(false);
    $('body,html').animate({
      scrollTop: hrefOffset
    }, 800);
    return false;
  });

  $(document).on('click', '.lpFoodVideoWrapperCnt > img', function (ev) {
    const parent = $(this).parent();
    $(this).fadeOut(100, () => {
      $('.lpFoodVideoWrapper', parent).animate({
        'opacity' : 1
      });
      $('.lpFoodVideoWrapper iframe', parent)[0].src += '&autoplay=1';
      ev.preventDefault();
    });
    // $('.lpFoodVideoWrapper', parent).fadeIn();
  });

  let bannerWidgetOffsetTop = 0;

  $('.banner-widget').each(function () {
    bannerWidgetOffsetTop = $(this).offset().top;
  });

  $(window).on('load', () => {
    $('.banner-widget').each(function () {
      bannerWidgetOffsetTop = $(this).offset().top;
    });
  });

  $(window).on('resize', () => {
    $('.banner-widget').each(function () {
      bannerWidgetOffsetTop = $(this).offset().top;
    });
  });

  $(window).on('scroll', () => {
    $('.banner-widget').each(function () {
      const headerHeight = $('.logo').outerHeight(false);
      const articleAsideOffsetTop = $('.article-aside').offset().top + $('.article-aside').outerHeight(false);
      const bannerHeight = $('.banner-widget').outerHeight(false);
      const scrollTop = $(window).scrollTop();

      if (scrollTop > (articleAsideOffsetTop - bannerHeight - headerHeight)) {
        $(this).removeClass('banner-widget-scrolled-fixed');
        $(this).addClass('banner-widget-scrolled-absolute');
        $(this).css({
          'bottom' : 0,
          'top' : 'auto'
        });
      } else if (scrollTop > (bannerWidgetOffsetTop - headerHeight)) {
        $(this).removeClass('banner-widget-scrolled-absolute');
        $(this).addClass('banner-widget-scrolled-fixed');
        $(this).css({
          'top' : `${headerHeight}px`,
          'bottom' : 'auto'
        });
      } else {
        $(this).removeClass('banner-widget-scrolled-fixed');
        $(this).removeClass('banner-widget-scrolled-absolute');
        $(this).removeAttr('style');
      }
    });

    $('.registration-right-col-in').each(function () {
      if ($(window).width() >= 974) {
        const scrollTop = $(window).scrollTop();
        const headerHeight = $('.p-header').outerHeight(false);
        const titleHeight = $('.ac.smallest').outerHeight(true);
        const height = $(this).outerHeight(false);
        const offsetTop = $('.registration-right-col').offset().top;
        const leftColOffsetTop = $('.registration-left-col').offset().top;
        const leftColHeight = $('.registration-left-col').outerHeight(false);
        const width = $('.registration-right-col').width();

        if (scrollTop > (offsetTop + headerHeight - 20 - titleHeight)) {
          // $(this).addClass('registration-right-col-in-scrolled-fixed').css({'width' : width + 'px', 'top' : headerHeight + 20 + 'px'});

          if ((leftColOffsetTop + leftColHeight + titleHeight - 20) < (scrollTop + offsetTop + height)) {
            $(this).removeClass('registration-right-col-in-scrolled-fixed').addClass('registration-right-col-in-scrolled-absolute').css({ 'width' : `${width}px`, 'top' : 'auto', 'bottom' : 0 });
          } else {
            $(this).removeClass('registration-right-col-in-scrolled-absolute').addClass('registration-right-col-in-scrolled-fixed').css({ 'width' : `${width}px`, 'top' : `${headerHeight + 20}px`, 'bottom' : 'auto' });
          }
        } else {
          $(this).removeClass('registration-right-col-in-scrolled-fixed');
          $(this).removeAttr('style');
        }
      }
    });
  });

  $(document).on('click', '.closeCookiePolicyBanner', () => {
    $('.container__cookiesPolicy').fadeOut();
  });

  $(document).on('click', '.km-brand-disclaimer .btn', () => {
    if (dataLayer) {
      $.getJSON('http://www.geoplugin.net/json.gp?jsoncallback=?', (data) => {
        dataLayer.push({
          'event': 'fgConsent',
          'fgAction': 'accept', // např. ‘accept’
          'fgCategory': null,
          'fgValidUntil': 'unlimited',
          'fgIp': data.geoplugin_request,
          'fgDomain': 'klubmaminek.cz',
          'fgLanguage': 'cs',
          'fgSource': `${document.title} disclaimer`
        });
      });
    }
  });

  $(document).on('click', '.js_acceptCookies', () => {
    if (dataLayer) {
      $.getJSON('http://www.geoplugin.net/json.gp?jsoncallback=?', (data) => {
        dataLayer.push({
          'event': 'fgConsent',
          'fgAction': 'accept',
          'fgCategory': null,
          'fgValidUntil': 'unlimited',
          'fgIp': data.geoplugin_request,
          'fgDomain': 'klubmaminek.cz',
          'fgLanguage': 'cs',
          'fgSource': `${document.title} cookie lišta`
        });
      });
    }
  });

  $(document).on('click', 'a', function () {
    const url = $(this).attr('href');
    if (url.substring(url.lastIndexOf('.') + 1) == 'pdf') {
      dataLayer.push({
        'event': 'ga_event',
        'eventData': {
          'category': 'Stazeni PDF',
          'action': url,
          'label': '',
          'value': 0
        }
      });
    }
  });

  $(document).on('click', '#rememberMe', () => {
    dataLayer.push({
      'event': 'ga_event',
      'eventData': {
        'category': 'Přihlášení',
        'action': 'Remember me',
        'label': '',
        'value': 0
      }
    });
  });

  $(document).on('click', 'body > div', function () {
    const text = $(this).text();
    if (text === 'Napište nám.') {
      dataLayer.push({
        'event': 'ga_event',
        'eventData': {
          'category': 'Engagement',
          'action': 'Napište nám klik',
          'label': '',
          'value': 0
        }
      });
    }
  });

  $(document).on('click', '.competition-btn-link .btn', function () {
    const competitionTitle = $(this).attr('data-competitionTitle');
    console.log(competitionTitle);
    dataLayer.push({
      'event': 'ga_event',
      'eventData': {
        'category': 'Chci soutěžit',
        'action': competitionTitle,
        'label': '',
        'value': 0
      }
    });
  });

  $(document).on('click', '.km-brand-disclaimer .btn', () => {
    if (dataLayer) {
      $.get('https://jsonip.com', (data) => {
        dataLayer.push({
          'event': 'fgConsent',
          'fgAction': 'accept',
          'fgCategory': 'disclaimer',
          'fgValidUntil': 'unlimited',
          'fgIp': data.ip,
          'fgDomain': 'klubmaminek.cz',
          'fgLanguage': 'cs',
          'fgPlacement': document.title
        });
      });
    }
  });

  $(document).on('click', '.js_acceptCookies', () => {
    if (dataLayer) {
      $.get('https://jsonip.com', (data) => {
        dataLayer.push({
          'event': 'fgConsent',
          'fgAction': 'accept',
          'fgCategory': 'cookie lišta',
          'fgValidUntil': 'unlimited',
          'fgIp': data.ip,
          'fgDomain': 'klubmaminek.cz',
          'fgLanguage': 'cs',
          'fgPlacement': document.title
        });
      });
    }
  });

  $(document).on('mouseenter', '.viaggioProductsList > li', function () {
    const country = $(this).data('country');
    $('.countryImages > li').removeClass('hovered');
    if (country == 3) {
      $('.countryImages > li[data-country="3"], .countryImages > li[data-country="4"]').addClass('hovered');
    } else {
      $(`.countryImages > li[data-country="${country}"]`).addClass('hovered');
    }
  });

  $(document).on('click', '.viaggioVideoCnt', function () {
    $('.viaggioVideoCntIn').fadeOut();
    const videoCode = $(this).data('video');
    $(this).append(`<div class="videoWrapper"><iframe width="560" height="315" frameborder="0" allowfullscreen src="https://www.youtube.com/embed/${videoCode}?autoplay=1&rel=0"></iframe></div>`);
  });
});

/**
 * GTM events - musi byt za $() inicializaci
 */
gaDimensionUser();
gaDimensionChildAge();
gaSeachForm();
gaCtaBannerEvents();

// LastVisitedUrlEnhanced - slouzi pro odscrollovani na dany target na strance, ze ktere se slo na prihlaseni / registraci
const lastVisitedUrlEnhancedInstance = new LastVisitedUrlEnhanced();

// h1 has to remove
$('.hp .logo a').on('click', () => {
  window.utils.saveStateToHistory('feedListing', {});
});

/**
 * schovani vsech nepotrebnych fieldsetu v ramci profileDialogu, musi byt za inline skripty - kvuli scrollovani
 */
$('.js_remove-unneeded-fieldsets').profileDialog({
  fieldsetSelector: '.js_remove-unneeded-fieldsets--fieldset'
});

$(document).on('click', '#footerCookieConsent', () => {
  $(window).trigger('CookiebotOnDialogDisplayCustom');
});

/* Cookiebot handling */
$(window).on('CookiebotOnDialogDisplay', () => {
  $('#CybotCookiebotDialogBodyLevelButtonPreferences, #CybotCookiebotDialogBodyLevelButtonStatistics, #CybotCookiebotDialogBodyLevelButtonMarketing').prop('checked', true);
});

/* $(window).on('load', function() {

  var cbCustomDisplayTimeout = setTimeout(function() {
    $('#CybotCookiebotDialogBodyButtons').append('<a id="CybotCookiebotDialogBodyButtonAcceptCustom" class="CybotCookiebotDialogBodyButton" href="javascript: void(0);" tabindex="0" style="padding-left: 12px; padding-right: 12px;" lang="cs"> Přijmout všechny cookies </a>');
    $('#CybotCookiebotDialogBodyButtonAccept').text('Přijmout zvolené cookies');
    $('#CybotCookiebotDialogBodyButtonDetails').text('Upravit preference');
    $('#CybotCookiebotDialogDetailFooter').addClass('clearfix');
    $('#CybotCookiebotDialogDetailFooter').prepend('<a id="CybotCookiebotDialogBodyButtonAcceptChosenCustom" class="CybotCookiebotDialogBodyButton" href="javascript: void(0);" tabindex="0" style="padding-left: 12px; padding-right: 12px;" lang="cs"> Přijmout zvolené cookies </a>');
    console.log('CB initiated');
  }, 1500);

  var cbCustomTimeout = setTimeout(function(){
    $('#CybotCookiebotDialogBodyButtonDetails').text('Upravit preference');
  }, 800);

});

$(window).on('CookiebotOnDialogDisplayCustom', function() {

  var cbAllCustomTimeout = setTimeout(function(){
    $('#CybotCookiebotDialogBodyButtons').append('<a id="CybotCookiebotDialogBodyButtonAcceptCustom" class="CybotCookiebotDialogBodyButton" href="javascript: void(0);" tabindex="0" style="padding-left: 12px; padding-right: 12px;" lang="cs"> Přijmout všechny cookies </a>');
      $('#CybotCookiebotDialogBodyButtonAccept').text('Přijmout zvolené cookies');
      $('#CybotCookiebotDialogBodyButtonDetails').text('Upravit preference');
      $('#CybotCookiebotDialogDetailFooter').addClass('clearfix');
      $('#CybotCookiebotDialogDetailFooter').prepend('<a id="CybotCookiebotDialogBodyButtonAcceptChosenCustom" class="CybotCookiebotDialogBodyButton" href="javascript: void(0);" tabindex="0" style="padding-left: 12px; padding-right: 12px;" lang="cs"> Přijmout zvolené cookies </a>');
    }, 2000);

    var cbCustomTimeout = setTimeout(function(){
      $('#CybotCookiebotDialogBodyButtonDetails').text('Upravit preference');
    }, 2000);
});

$(document).on('click', '#CybotCookiebotDialogBodyButtonAcceptCustom', function() {
  $('#CybotCookiebotDialogBodyLevelButtonPreferences, #CybotCookiebotDialogBodyLevelButtonStatistics, #CybotCookiebotDialogBodyLevelButtonMarketing').prop('checked', true);
  $('#CybotCookiebotDialogBodyButtonAccept').trigger('click');
  *//* var timeout = setTimeout(function() {
    location.reload();
  }, 500); *//*
});

$(document).on('click', '#CybotCookiebotDialogBodyButtonAcceptChosenCustom', function() {
  $('#CybotCookiebotDialogBodyButtonAccept').trigger('click');
    *//* var timeout = setTimeout(function() {
      location.reload();
    }, 500); *//*
});

$(document).on('click', '#CybotCookiebotDialogBodyButtonDetails', function() {
  $('#CybotCookiebotDialogBodyButtonDetails').text('Upravit preference');
});

$(document).on('click', '.CybotCookiebotDialogBodyLink', function() {
    if ($(this).hasClass('CybotCookiebotDialogBodyLinkExpanded')) {
      //$('#CybotCookiebotDialogBodyButtonAcceptCustom').hide();
      $('#CybotCookiebotDialogBodyButtonAccept').show();
    } else {
      $('#CybotCookiebotDialogBodyButtonAccept').hide();
      //$('#CybotCookiebotDialogBodyButtonAcceptCustom').show();
    }
}); */

window.addEventListener('load', (event) => {
  fgSiteVisit30();
});

const checkCookieExistence = (cookieName) => {
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.indexOf(`${cookieName}=`) === 0) {
      return true;
    }
  }

  return false;
};

const getCookieValue = (cookieName) => {
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.indexOf(`${cookieName}=`) === 0) {
      return cookie.substring(cookieName.length + 1, cookie.length);
    }
  }

  return null;
};

const setCookie = (cookieName, cookieValue, expirationDays) => {
  const date = new Date();
  date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${cookieName}=${cookieValue}; ${expires}; path=/`;
};

const deleteCookie = (cookieName) => {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

const fgSiteVisit30DataLayer = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'fgSiteVisit30'
  });

  setCookie('fgSiteVisit30', true, 365);
};


let fgSiteVisit30 = () => {
  const isFgSiteVisit30Exists = checkCookieExistence('fgSiteVisit30');

  if (!isFgSiteVisit30Exists) {
    const timeout = setTimeout(fgSiteVisit30DataLayer, 30000);
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web.js